var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field RMPE-CustomField"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"RMPE-CustomLabel content",class:_vm.labelStyle},[_c('div',{ref:"labelContent",domProps:{"innerHTML":_vm._s(_vm.question.label)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }